import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store/store'
Vue.use(ElementUI)

import Vuex from 'vuex'
Vue.use(Vuex)

Vue.prototype.bus = new Vue()

Vue.directive('drag',{
    inserted: function (el) {
        let dragBox = el;
        dragBox.onmousedown = e => {
            //算出鼠标相对元素的位置
            let disX = e.clientX - dragBox.offsetLeft;
            let disY = e.clientY - dragBox.offsetTop;
            document.onmousemove = e => {
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX;
                let top = e.clientY - disY;
                //移动当前元素
                dragBox.style.left = left + "px";
                dragBox.style.top = top + "px";
            };
            document.onmouseup = e => {
                //鼠标弹起来的时候不再移动
                document.onmousemove = null;
                //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
                document.onmouseup = null;
            };
        };
    }
})
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts

Vue.config.productionTip = false;
global.token = 'VrMakerToken'
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");